import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { PathInvModel } from '../models/PathInvModel';
import { URLsConfig } from '../URLsConfig';

@Injectable()
export class PathInvService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }

  public getPathInvAll(pathinvcode: string , compcode: string) {

      let params = new HttpParams();
        params = params.append("PathInvCode", pathinvcode);
        params = params.append("CompCode", compcode);

        const options = {
          params: params
      };
      return this.http.get<PathInvModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/PathInv/GetPathInv',options);
    }


    public AddPathInv(pathInv: PathInvModel) {
      return this.http.post<PathInvModel>(this.urlsconfig.WebAPIURL_Test + 'api/PathInv/AddPAthInv', pathInv);
    }

    public delPathInv_Line(pathinvcode: string ,pdate: string, compcode: string) {

    let params = new HttpParams();
    params = params.append("PathInvCode", pathinvcode);
    params = params.append("PDate", pdate);
    params = params.append("CompCode", compcode);


      const options = {
        params: params
    };
    return this.http.delete<PathInvModel>(this.urlsconfig.WebAPIURL_Test + 'api/PathInv/DeletePathInv',options);
    }

  }
